import React, { Component, Fragment, ReactNode } from 'react'
import { compact, map } from 'lodash'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../../routes/routes'
import userApi, { UserData } from '../../apis/user.api'
import authService from '../../services/auth.service'
import storageService from '../../services/storage.service'
import { connector, PanelStateProps } from './Panel.state'
import MobileHeader from '../MobileHeader'
import Sidebar from '../Sidebar'
import Logo from '../Logo'
import SiteSetupStatus from '../../partials/SiteSetupStatus'

export interface PanelProps {
  children: ReactNode
}

type PanelCombinedProps = PanelProps & PanelStateProps & RouteComponentProps

interface PanelState {
  user: UserData | null
}

class Panel extends Component<PanelCombinedProps, PanelState> {
  constructor (props: PanelCombinedProps) {
    super(props)
    this.state = {
      user: null
    }
    this.handleLogoClick = this.handleLogoClick.bind(this)
  }

  get permittedModules (): string[] {
    const { user } = this.state
    if (!user || !user.permissions) return []
    const modules = map(user.permissions, permission => {
      if (!permission.module) return null
      return permission.module.name
    })
    return compact(modules)
  }

  handleLogoClick () {
    this.props.history.push(routes.dashboard)
  }

  readUser () {
    const authData = authService.tokenData()
    if (!authData) return
    const { id } = authData
    userApi.read(id, user => {
      if (!user) return
      this.setState({ user })
    })
  }

  componentDidMount () {
    this.readUser()
  }

  render () {
    return (
      <Fragment>
        <div className="bg-split">
          <div className="mx-auto">
            <div className="flex">
              <Sidebar
                visible={this.props.sidebar}
                user={this.state.user}
                permittedModules={this.permittedModules}
                onClose={this.props.sidebarClose}
                onRoute={this.props.sidebarClose} />
              <div className="bg-tertiary w-full h-screen overflow-auto ">
                <MobileHeader
                  onSidebarOpen={this.props.sidebarOpen}
                  onLogoClick={this.handleLogoClick} />
                <div className="flex flex-col justify-between p-5 min-h-full">
                  {this.props.children}
                  <div className="justify-end py-2 flex">
                    <Logo type="full" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SiteSetupStatus />
      </Fragment>
    )
  }
}

export default connector(withRouter(Panel))
